import {
  AnchorButton,
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  InputGroup,
  NumericInput,
  Popover,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, indianRupee, niceDate, niceDateTime } from "../fns/util";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import cogoToast from "cogo-toast";
import { DateInput } from "@blueprintjs/datetime";

class SxPayments extends React.Component {
  state = {
    collapsed: true,
    amountPaise: 0,
    authType: null,
    edit: false,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  calculateCurrentBalance = () => {
    return (
      this.props.data.totalBillAmountPaise -
      this.props.data.totalCashPaidAmountPaise -
      this.props.data.totalCashlessAmountPaise
    );
  };
  renderCurrentBalance = () => {
    let bal = this.calculateCurrentBalance();
    if (Math.abs(bal) < 99) {
      return (
        <Tag intent="success" minimal large>
          Account settled
        </Tag>
      );
    }
    if (bal < 0) {
      return (
        <Tag intent="danger" minimal large>
          Refund needed: {indianRupee(bal)}
        </Tag>
      );
    }
    if (bal > 0) {
      return (
        <Tag intent="warning" minimal large>
          Payment needed: {indianRupee(bal)}
        </Tag>
      );
    }
  };
  paymentRefs = (index) => {
    let arg = this.props.data.paymentEvents[index]["paymentMode"];
    let entries = this.props.data.paymentEvents[index];
    console.log("arg", arg);
    if (!arg) return null;
    if (arg === "Cash") {
      return null;
    }
    if (arg === "Card") {
      return (
        <>
          <Tag intent="primary" large minimal>
            Last 4 Digits
          </Tag>
          <Tag large>{entries.reference.last4}</Tag>
          <Tag intent="primary" large minimal>
            Cardholder
          </Tag>
          <Tag large>{entries.reference.cardName}</Tag>
        </>
      );
    }

    if (arg === "Cheque") {
      return (
        <>
          <Tag large minimal>
            Cheque Number
          </Tag>
          <Tag large>{entries?.reference?.chqNo}</Tag>
          <Tag large minimal>
            Dated
          </Tag>

          <Tag large>{niceDate(entries?.reference?.chqDate)}</Tag>
        </>
      );
    }

    if (arg === "UPI") {
      return (
        <>
          <Tag large minimal>
            Linked Phone Number for {arg}
          </Tag>
          <Tag large>{entries?.reference?.phone}</Tag>
        </>
      );
    }
  };

  renderDetail = () => {
    if (!this.state.paymentMode) {
      return null;
    }
    if (this.state.paymentMode === "Cash") {
      return;
    }
    if (this.state.paymentMode === "Card") {
      return (
        <>
          <Tag large minimal>
            Last 4 Digits
          </Tag>
          <InputGroup
            onChange={(event) => this.setState({ last4: event.target.value })}
          />
          <Tag large minimal>
            Cardholder Name
          </Tag>
          <InputGroup
            onChange={(event) =>
              this.setState({ cardName: event.target.value })
            }
          />
        </>
      );
    }
    if (this.state.paymentMode === "Cheque") {
      return (
        <>
          <Tag large minimal>
            Cheque Number
          </Tag>
          <InputGroup
            onChange={(event) => this.setState({ chqNo: event.target.value })}
          />
          <Tag large minimal>
            Dated
          </Tag>
          <DateInput
            formatDate={(date) => niceDate(date)}
            parseDate={(str) => new Date(str)}
            onChange={(value) => this.setState({ chqDate: value })}
            maxDate={new Date()}
            placeholder="Choose Date"
          />
        </>
      );
    }
    if (
      this.state.paymentMode === "UPI" ||
      this.state.paymentMode === "PayTM"
    ) {
      return (
        <>
          <Tag large minimal>
            Linked Phone Number
          </Tag>
          <InputGroup
            onChange={(event) => this.setState({ phone: event.target.value })}
          />
        </>
      );
    }
  };
  renderAddPayment = () => {
    let bal = this.calculateCurrentBalance();
    let paymentModes = ["Cash", "Card", "Cheque", "NEFT", "UPI", "ABDM", "NA"];
    let trxTypes = ["Discount"];

    trxTypes.push("Payment");
    trxTypes.push("Refund");

    return (
      <div>
        <div>
          <div>{this.renderCurrentBalance()}</div>
        </div>
        <br /> <br />
        <ControlGroup>
          {/* <Tag intent="primary" large minimal>
            New Tranaction
          </Tag> */}
          <Tag intent="primary" large minimal>
            Type
          </Tag>
          <SingleSelectWrapper
            items={trxTypes}
            selectedItem={this.state.paymentType}
            onChange={(value) =>
              this.setState({ paymentType: value }, () => {
                if (value === "Discount") {
                  this.setState({ paymentMode: "DISCOUNT" });
                }
                if (value === "Refund") {
                  this.setState({ paymentMode: "REFUND" });
                }
              })
            }
            showSelectProp={true}
          />
          {this.state.paymentType !== "Discount" && (
            <>
              {" "}
              <Tag intent="primary" large minimal>
                Mode
              </Tag>
              <SingleSelectWrapper
                disabled={!this.state.paymentType}
                items={paymentModes}
                selectedItem={this.state.paymentMode}
                onChange={(value) => this.setState({ paymentMode: value })}
                showSelectProp={true}
              />
            </>
          )}
          {this.renderDetail()}
          <Tag intent="primary" large minimal>
            {this.state.paymentType === "Discount"
              ? "Discount Reason"
              : this.state.paymentType === "Refund"
              ? "Refund Reason"
              : "Payment Reference"}
          </Tag>
          <InputGroup
            placeholder="Reference"
            disabled={!this.state.paymentType}
            value={this.state.paymentRef}
            onChange={(event) => {
              this.setState({ paymentRef: event.target.value });
            }}
          />
          <Tag intent="primary" large minimal>
            Amount
          </Tag>
          <NumericInput
            disabled={
              !this.state.paymentType ||
              !this.state.paymentRef ||
              !this.state.paymentMode
            }
            // max={
            //   this.state.paymentType === "Payment"
            //     ? bal / 100
            //     : this.state.paymentType === "Refund"
            //     ? bal
            //     : this.state.paymentType === "Discount"
            //     ? this.props.data.totalBillAmountPaise / 100
            //     : 1
            // }
            // min={1}
            // clampValueOnBlur
            style={{ width: "7em" }}
            rightElement={<Tag minimal>₹</Tag>}
            buttonPosition="none"
            value={this.state.amountPaise / 100}
            onValueChange={(number) => {
              this.setState({ amountPaise: number * 100 });
            }}
          />
          <Button
            icon="add"
            outlined
            onClick={() => {
              if (!this.state.paymentType) {
                cogoToast.error("Transaction type not selected");
                return;
              }
              if (!this.state.paymentRef) {
                cogoToast.error("Payment reference not entered");
                return;
              }
              if (!this.state.amountPaise) {
                cogoToast.error("Amount not entered");
                return;
              }
              if (!this.state.paymentMode) {
                cogoToast.error("Payment mode not selected");
                return;
              }
              let reference = {};
              if (this.state.paymentMode === "Card") {
                reference["last4"] = this.state.last4;
                reference["cardName"] = this.state.cardName;
              }
              if (this.state.paymentMode === "Cheque") {
                reference["chqNo"] = this.state?.chqNo;
                reference["chqDate"] = this.state?.chqDate;
              }
              if (
                this.state.paymentMode === "UPI" ||
                this.state.paymentMode === "PayTM"
              ) {
                reference["phone"] = this.state.phone;
              }

              let payload = {
                ts: new Date(),
                transactionType: this.state.paymentType,
                paymentMode: this.state.paymentMode,
                paymentRef: this.state.paymentRef,
                amountPaise: this.state.amountPaise,
                createdBy: this.props.authStore.name,
                reference: reference,
              };
              this.props.onUpdate({
                paymentEvents: [...this.props.data.paymentEvents, payload],
                totalCashPaidAmountPaise:
                  this.props.data.totalCashPaidAmountPaise +
                  (this.state.paymentType === "Refund" ? -1 : 1) *
                    this.state.amountPaise,
              });
              this.setState({
                amountPaise: 0,
                paymentType: null,
                paymentMode: null,
                paymentRef: "",
              });
            }}
          />
        </ControlGroup>
      </div>
    );
  };
  renderPriorPayments = () => {
    let bal = this.calculateCurrentBalance();
    let pp = this.props.data.paymentEvents;
    if (!pp || !pp.length) return null;
    return pp.map((each, index) => {
      return (
        <ControlGroup style={{ marginTop: "5px" }}>
          <Tag large minimal>
            {niceDateTime(each.ts)}
          </Tag>
          <Tag large minimal>
            {each.createdBy}
          </Tag>
          <Tag
            large
            intent={
              each.transactionType === "Payment"
                ? "success"
                : each.transactionType === "Refund"
                ? "danger"
                : "warning"
            }
            minimal
          >
            {each.transactionType}
          </Tag>
          {each.transactionType === "Discount" ? null : (
            <Popover
              captureDismiss={true}
              content={
                this.props.authStore.scope.includes("surgery:admin") ? (
                  <SingleSelectWrapper
                    items={["Cash", "Card", "Cheque", "DD", "UPI", "PayTM", "ABDM"]}
                    showSelectProp={true}
                    selectedItem={""}
                    onChange={async (item) => {
                      const newPaymentHistory = this.props.data.paymentEvents;
                      newPaymentHistory[index]["paymentMode"] = item;

                      this.props.onUpdate({
                        paymentEvents: newPaymentHistory,
                      });
                      this.setState({ edit: true });
                    }}
                  />
                ) : (
                  ""
                )
              }
              placement="bottom-start"
            >
              <Tag large minimal>
                {this.props.data.paymentEvents[index]["paymentMode"]}
              </Tag>
            </Popover>
          )}
          {this.paymentRefs(index)}
          <Popover
            captureDismiss={true}
            content={
              this.props.authStore.scope.includes("surgery:admin") ? (
                <NumericInput
                  min={1}
                  clampValueOnBlur
                  max={bal / 100}
                  value={
                    this.props.data.paymentEvents[index]["amountPaise"] / 100
                  }
                  buttonPosition="NONE"
                  rightElement={<Tag intent="primary">₹</Tag>}
                  style={{ width: "7em" }}
                  onValueChange={async (number) => {
                    const newPaymentHistory = this.props.data.paymentEvents;
                    newPaymentHistory[index]["amountPaise"] = number * 100;
                    this.props.onUpdate({
                      paymentEvents: newPaymentHistory,
                    });
                    this.setState({ edit: true });
                  }}
                />
              ) : (
                ""
              )
            }
            placement="bottom-start"
          >
            <Tag large minimal>
              {indianRupee(this.props.data.paymentEvents[index]["amountPaise"])}
            </Tag>
          </Popover>
          <Popover
            captureDismiss={true}
            content={
              this.props.authStore.scope.includes("surgery:admin") ? (
                <InputGroup
                  placeholder="Reference"
                  value={this.props.data.paymentEvents[index]["paymentRef"]}
                  onChange={(event) => {
                    const newPaymentHistory = this.props.data.paymentEvents;
                    newPaymentHistory[index]["paymentRef"] = event.target.value;

                    this.props.onUpdate({
                      paymentEvents: newPaymentHistory,
                    });
                    this.setState({ edit: true });
                  }}
                />
              ) : (
                ""
              )
            }
            placement="bottom-start"
          >
            <Tag large minimal>
              Ref: {this.props.data.paymentEvents[index]["paymentRef"] || "NA"}
            </Tag>
          </Popover>
          {each.transactionType === "Payment" ||
          each.transactionType === "Refund" ? (
            <AnchorButton
              style={{ marginLeft: "5px" }}
              outlined
              target="_blank"
              icon="credit-card"
              href={`https://print.newchart.care/sxPayment/cashReciept/${this.state._id}/${index}`}
            ></AnchorButton>
          ) : null}
          {this.props.authStore.scope.includes("surgery:admin") ? (
            <Button
              icon="trash"
              outlined
              onClick={async () => {
                let newPaymentHistory = this.props.data.paymentEvents.filter(
                  (item, i) => i !== index
                );

                try {
                  let res = await apiCallPost(
                    `/booking-sx/${this.props.authStore.prefix}/sxBooking/admin/overwritePaymentHistory`,
                    {
                      _id: this.state._id,
                      indexValue: index,
                      paymentEvents: newPaymentHistory,
                      totalCashPaidAmountPaise:
                        this.props.data.totalCashPaidAmountPaise -
                        (this.props.data.paymentEvents[index]
                          .transactionType === "Refund"
                          ? -1
                          : 1) *
                          this.props.data.paymentEvents[index].amountPaise,
                    }
                  );
                } catch (err) {
                  cogoToast.error("Error in deleting the payment entry", err);
                }
                this.props.onUpdate({
                  paymentEvents: newPaymentHistory,
                  totalCashPaidAmountPaise:
                    this.props.data.totalCashPaidAmountPaise -
                    (this.props.data.paymentEvents[index].transactionType ===
                    "Refund"
                      ? -1
                      : 1) *
                      this.props.data.paymentEvents[index].amountPaise,
                });
              }}
            />
          ) : null}
          {this.props.authStore.scope.includes("surgery:admin") ? (
            <Button
              icon="automatic-updates"
              disabled={!this.state.edit}
              outlined
              onClick={async () => {
                try {
                  let res = await apiCallPost(
                    `/booking-sx/${this.props.authStore.prefix}/sxBooking/admin/overwritePaymentHistory`,
                    {
                      _id: this.state._id,
                      indexValue: index,
                      paymentEvents: this.props.data.paymentEvents,
                      totalCashPaidAmountPaise:
                        this.props.data.paymentEvents[index].amountPaise,
                    }
                  );

                  this.setState({ edit: false });
                } catch (err) {
                  cogoToast.error("Error in updating the paidAmountPaise", err);
                }
                this.props.onUpdate({
                  paymentEvents: this.props.data.paymentEvents,
                  totalCashPaidAmountPaise:
                    this.props.data.paymentEvents[index].amountPaise,
                });
              }}
            />
          ) : null}
        </ControlGroup>
      );
    });
  };
  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Payment Events
            </Tag>
            {this.renderCurrentBalance()}{" "}
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>{" "}
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Payment Events
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              {this.renderAddPayment()}
              {this.renderPriorPayments()}
              <br />
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SxPayments)));
